var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMassageChair = function SvgMassageChair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 19.68 23.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M16.616 19.85c1.36 0 2.464-.603 2.464-1.882v-4.631c0-1.28-1.103-2.316-2.464-2.316m0 8.829v2.75H3.064v-2.75m13.552 0H3.064m0 0C1.704 19.85.6 19.247.6 17.968v-4.631c0-1.28 1.103-2.316 2.464-2.316m13.552 0c-1.36 0-2.464 1.037-2.464 2.316v2.316H5.528v-2.316c0-1.28-1.103-2.316-2.464-2.316m13.552 0V9.863M3.064 11.021V9.863m0 0c0-1.918 1.655-3.474 3.696-3.474h6.16c2.041 0 3.696 1.556 3.696 3.474m-13.552 0V2.6a2 2 0 0 1 2-2h9.552a2 2 0 0 1 2 2v7.263"
  })));
};
export default SvgMassageChair;